import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEEarTargetType = {
    anatomy:        'anatomy'
};

OEEarTargetType.all = [
    OEEarTargetType.anatomy
];

export const OEEarStartSelectionContent = {

    // alpha
    [OEEarTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.sensorySystems
                    ]
                }
            ]
        }
    ],

    // beta
    [OEEarTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.sensorySystems
                    ]
                }
            ]
        }
    ],

    // prod
    [OEEarTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.sensorySystems
                    ]
                }
            ]
        }
    ]
};

OEEarStartSelectionContent.modules = [
    {id: OEEarTargetType.anatomy, icon: OEIconCodes.ear.anatomyTarget, categories: OEEarStartSelectionContent[OEEarTargetType.anatomy]},
];

OEEarStartSelectionContent.modulesBeta = [
    {id: OEEarTargetType.anatomy, icon: OEIconCodes.ear.anatomyTarget, categories: OEEarStartSelectionContent[OEEarTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
];

OEEarStartSelectionContent.modulesProduction = [
    {id: OEEarTargetType.anatomy, icon: OEIconCodes.ear.anatomyTarget, categories: OEEarStartSelectionContent[OEEarTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
];
